import { P2TextDescription } from "react-bootstrap-common-script";
import { SectionCard } from "../../../components/card";
import { Stepper } from "../../../components/stepper";
import { StructureStatusEnum } from "../../../models/enum/structure-status.enum";
import { R2StageEStepperItems } from "../../../utils/shared-dropdown";
import CompletionReminderSegment from "../segments/completion-reminder";
import CPFWithdrawalEService from "../segments/cpf-withdrawal-e-service";
import DateTimeLocation from "../segments/date-time-location";
import DocumentsToBringSegment from "../segments/documents-to-bring";

interface StageE1ViewProps {
  struct: String;
}
const StageE1View = ({ struct }: StageE1ViewProps) => {
  const showCPFWithdrawal =
    struct === StructureStatusEnum.incoming ||
    struct === StructureStatusEnum.retaining;
    
  return (
    <>
      {/* Stepper */}
      <div>
        <Stepper activeStep={1} items={R2StageEStepperItems} />
      </div>
      {/* Section-Card */}
      <div>
        <div className="d-flex justify-content-center">
          <SectionCard
            required={false}
            className="flex-fill"
            activeStep={1}
            stepperItems={R2StageEStepperItems}
            titleChildren={
              <P2TextDescription title={`Before Completion Appointment`} />
            }
            contentChildren={
              <div className="polymer-stage-e">
                <div>
                  <CompletionReminderSegment />
                  <DateTimeLocation index={1} />
                  {showCPFWithdrawal && <CPFWithdrawalEService index={2} />}
                  <DocumentsToBringSegment index={showCPFWithdrawal ? 3 : 2} />
                </div>
              </div>
            }
          />
        </div>
      </div>
    </>
  );
};

export default StageE1View;
